var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlltick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.61133C4.8645 1.61133 1.5 4.97583 1.5 9.11133C1.5 13.2468 4.8645 16.6113 9 16.6113C13.1355 16.6113 16.5 13.2468 16.5 9.11133C16.5 8.26683 16.353 7.45698 16.0942 6.69873L14.8799 7.91309C14.9586 8.30009 15 8.70108 15 9.11133C15 12.4196 12.3082 15.1113 9 15.1113C5.69175 15.1113 3 12.4196 3 9.11133C3 5.80308 5.69175 3.11133 9 3.11133C10.2247 3.11133 11.3639 3.48175 12.3149 4.11475L13.3887 3.04102C12.1527 2.14552 10.6387 1.61133 9 1.61133ZM15.9697 2.58105L8.25 10.3008L5.78027 7.83105L4.71973 8.8916L8.25 12.4219L17.0303 3.6416L15.9697 2.58105Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlltick);
export default __webpack_public_path__ + "static/media/alltick.ceafae1c626552bfbc5fc6ffd3697dd6.svg";
export { ForwardRef as ReactComponent };